import { useTranslation } from '@cobliteam/i18n';
import Dialog from '@cobliteam/ui/components/Dialog';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Icon from '@cobliteam/ui/icons';

const AlertFooter = () => {
  const { t } = useTranslation('global-search');
  const isMac = /macintosh|mac os x/i.test(navigator.userAgent);

  return (
    <div className='flex h-10 w-full items-center justify-between border-gray-4 border-t px-4'>
      <Dialog>
        <Dialog.Trigger asChild>
          <div className='flex items-center gap-4 text-xs'>
            <button type='button' className='flex gap-1 font-semibold text-gray-9 text-xs hover:underline'>
              <Icon name='message-square-warning' size='xs' className='mt-0.5' /> {t('alert_footer.report_problem')}
            </button>
          </div>
        </Dialog.Trigger>
      </Dialog>

      <div className='flex items-center gap-2 text-xs'>
        <Tooltip content={t('alert_footer.shortcut_tooltip')}>
          <kbd className='inline-flex h-5 max-h-full items-center rounded border border-gray-5 bg-gray-2 px-1 font-[inherit] font-medium text-gray-a9 text-xs shadow-sm'>
            {isMac ? '⌘' : 'Ctrl'} + K
          </kbd>
        </Tooltip>
      </div>
    </div>
  );
};

export default AlertFooter;
